'use strict';

/** @export SYSTEM_CONSTANTS */
export default {
    APP_ENV: "prod",
    HIDDEN_DELIVERY: "true"
};


// WEBPACK FOOTER //
// ./assets/js/const.js